import { AlternateOwnership } from "../houseTypes";

export const canPurchaseHouse = (
  alternateOwnership: AlternateOwnership,
): boolean => alternateOwnership !== AlternateOwnership.NOT_OWNED;
